import React from 'react';
import { BarChart, Bar, XAxis, YAxis, Tooltip, CartesianGrid, ResponsiveContainer, Legend } from 'recharts';

const FPSBarChart = () => {
  // ⚠️ 你可以替换下面数据为真实测得的 FPS 值
  const data = [
    { name: 'TrackMate', FPS: 12 },
    { name: 'uTrack', FPS: 15 },
    { name: 'SPTNet', FPS: 28 },
    { name: 'DeepTrack', FPS: 22 },
    { name: 'BNP-Track', FPS: 9 },
    { name: 'DT-NML', FPS: 35 },
  ];

  return (
    <div className="w-full h-[350px] bg-white rounded shadow p-4">
      <ResponsiveContainer width="100%" height="100%">
        <BarChart data={data} margin={{ top: 20, right: 30, left: 0, bottom: 5 }}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="name" />
          <YAxis label={{ value: 'Frames per Second (FPS)', angle: -90, position: 'insideLeft' }} />
          <Tooltip />
          <Legend />
          <Bar dataKey="FPS" fill="#8884d8" barSize={40} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  );
};

export default FPSBarChart;
